import variables from "../configs/variables.json";

const checkSpecialRole = (role) => {
  return variables.disableRole.indexOf(role.toUpperCase()) !== -1;
}

export {
  checkSpecialRole,
}
